const C = require("../constants");

const salesOpenTable = (data) => {
    return {
        type: C.SALES_OPEN_TABLE,
        data
    }
};

const salesUpdateTable = (data) => {
    return {
        type: C.SALES_TABLE_UPDATE,
        data
    }
};

export {
    salesOpenTable,
    salesUpdateTable
};


// WEBPACK FOOTER //
// ./src/actions/SalesTableAction.js